export default __webpack_public_path__ + "static/media/scnscyc.e09f94fb.png";